var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "div" }, [
    _c("div", { staticClass: "gs-worp" }, [
      _c("div", { staticClass: "gs-tab" }, [
        _c(
          "ul",
          _vm._l(_vm.tab, function(btn, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "xs",
                class: { gsactive: _vm.nowindex == index },
                on: {
                  click: function($event) {
                    _vm.tabswitch(index)
                  }
                }
              },
              [_vm._v(_vm._s(btn.name))]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gs-none" }, [
        _c("div", { class: { gsqiye: _vm.nowindex == 0 } }, [
          _vm.ismodifycompany
            ? _c(
                "div",
                {
                  staticClass: "over gr-worp",
                  staticStyle: { "margin-bottom": "100px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "left gr-right wspace",
                      staticStyle: { "margin-bottom": "50px" }
                    },
                    [
                      _c("div", { staticClass: "infoTitle" }, [
                        _vm._v("企业信息")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticStyle: { padding: "0" } }, [
                        _c("li", [
                          _c("span", [_vm._v("企业名称：")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "270px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.companyInfo.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "modifyname dianji",
                              on: {
                                click: function($event) {
                                  _vm.modify("company")
                                }
                              }
                            },
                            [_vm._v("修改")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("服务类型：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.apptype == "make-app"
                                  ? "制造云"
                                  : _vm.apptype == "trade-app"
                                  ? "贸易云"
                                  : ""
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("企业UU：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.companyInfo.uu))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("纳税人识别号：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.companyInfo.businessCode))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isadminiinfo
                        ? _c("div", { staticClass: "space" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isadminiinfo
                        ? _c("div", { staticClass: "infoTitle" }, [
                            _vm._v("管理员信息")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticStyle: { padding: "0" } },
                        _vm._l(_vm.adminList, function(d, i) {
                          return _c("li", { key: i }, [
                            _c("span", [_vm._v("姓名：")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "60px",
                                  display: "inline-block"
                                }
                              },
                              [_vm._v(_vm._s(d.realname))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "admininfo" }, [
                              _vm._v("手机号码：")
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(d.mobile))])
                          ])
                        })
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.ismodifycompany
            ? _c(
                "div",
                {
                  staticClass: "over gr-worp",
                  staticStyle: { "margin-bottom": "100px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "left gr-right wspace",
                      staticStyle: { "margin-bottom": "50px" }
                    },
                    [
                      _c("div", { staticClass: "infoTitle" }, [
                        _vm._v("企业信息")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticStyle: { padding: "0" } }, [
                        _c("li", [
                          _c("span", { staticClass: "xinghao" }, [
                            _vm._v("企业名称：")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            ref: "companyname",
                            staticStyle: { width: "270px" },
                            attrs: { type: "text" },
                            on: {
                              focus: function($event) {
                                _vm.hideregname("company")
                              },
                              blur: _vm.regcompany
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isuscompany,
                                expression: "isuscompany"
                              }
                            ],
                            key: "company",
                            ref: "uscompany",
                            staticClass: "usname"
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "baocun dianji",
                              on: { click: _vm.PreservationCompanyInfo }
                            },
                            [_vm._v("保存")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "qy-quxiao quxiao",
                              on: {
                                click: function($event) {
                                  _vm.cancel("company")
                                }
                              }
                            },
                            [_vm._v("取消")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("服务类型：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.mytoken.defaultCompany.app == "make-app"
                                  ? "制造云"
                                  : _vm.mytoken.defaultCompany.app ==
                                    "trade-app"
                                  ? "贸易云"
                                  : ""
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("企业UU：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.companyInfo.uu))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("纳税人识别号：")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.companyInfo.businessCode))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isadminiinfo
                          ? _c("div", { staticClass: "space" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isadminiinfo
                          ? _c("div", { staticClass: "infoTitle" }, [
                              _vm._v("管理员信息")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticStyle: { padding: "0" } },
                          _vm._l(_vm.adminList, function(d, i) {
                            return _c("li", { key: i }, [
                              _c("span", [_vm._v("姓名：")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "60px",
                                    display: "inline-block"
                                  }
                                },
                                [_vm._v(_vm._s(d.realname))]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "admininfo" }, [
                                _vm._v("手机号码：")
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(d.mobile))])
                            ])
                          })
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { class: { gsqiye: _vm.nowindex == 1 } }, [
          _vm.ismodifyname
            ? _c(
                "div",
                {
                  staticClass: "over gr-worp",
                  staticStyle: { "margin-bottom": "100px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "left gr-right wspace",
                      staticStyle: { "margin-bottom": "50px" }
                    },
                    [
                      _c("div", { staticClass: "infoTitle" }, [
                        _vm._v("个人信息")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticStyle: { padding: "0" } }, [
                        _c("li", [
                          _c("span", [_vm._v("姓名：")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "270px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.mytoken.realname))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "modifyname dianji",
                              on: { click: _vm.modify }
                            },
                            [_vm._v("修改")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("UU号：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.uu))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("邮箱：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.email))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("手机号：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.mobile))])
                        ])
                      ])
                    ]
                  )
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "over gr-worp",
                  staticStyle: { "margin-bottom": "100px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "left gr-right wspace",
                      staticStyle: { "margin-bottom": "30px" }
                    },
                    [
                      _c("div", { staticClass: "infoTitle" }, [
                        _vm._v("个人信息")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticStyle: { padding: "0" } }, [
                        _c("li", [
                          _c("span", { staticClass: "xinghao" }, [
                            _vm._v("姓名：")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            ref: "realname",
                            staticClass: "realname",
                            staticStyle: { width: "270px" },
                            attrs: { type: "text", value: "" },
                            on: { blur: _vm.regname, focus: _vm.hideregname }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isusname,
                                expression: "isusname"
                              }
                            ],
                            ref: "usname",
                            staticClass: "usname"
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "baocun dianji",
                              on: { click: _vm.Preservation }
                            },
                            [_vm._v("保存")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "qy-quxiao quxiao",
                              on: { click: _vm.cancel }
                            },
                            [_vm._v("取消")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("UU号：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.uu))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("邮箱：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.email))])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [_vm._v("手机号：")]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.mytoken.mobile))])
                        ])
                      ])
                    ]
                  )
                ]
              )
        ]),
        _vm._v(" "),
        _c("div", { class: { gsqiye: _vm.nowindex == 2 } }, [
          _c("div", { staticClass: "gs-anquanxinxi" }, [
            _c("div", { staticClass: "over aq-title" }, [
              _c("span", { staticClass: "left" }, [_vm._v("登录密码")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "right dianji",
                  attrs: {
                    href: _vm.$url.accountCenter + "/resetPassword",
                    target: "_blank"
                  }
                },
                [_vm._v("更换密码")]
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gs-anquanxinxi" }, [
            _c("div", { staticClass: "over aq-title" }, [
              _c("span", { staticClass: "left" }, [_vm._v("手机验证")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "right dianji",
                  attrs: {
                    href: _vm.$url.accountCenter + "/validationMobile.html",
                    target: "_blank"
                  }
                },
                [_vm._v("修改手机号")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "aq-text" }, [
              _c("p", [
                _vm._v(
                  "您绑定的手机：" +
                    _vm._s(_vm.mobile) +
                    "。若已丢失或停用，请立即更换，避免账户被盗。"
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { gsqiye: _vm.nowindex == 4 },
            staticStyle: { "margin-top": "40px" }
          },
          [
            _c(
              "div",
              {
                ref: "qiyebox",
                staticClass: "gs-news",
                class: _vm.isheigh ? "heigh" : ""
              },
              [
                _c(
                  "ul",
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.arr, function(d, i) {
                      return _vm.isnews
                        ? _c(
                            "li",
                            {
                              key: i,
                              staticClass: "newslist",
                              class: { newslist2: i % 2 == 0 }
                            },
                            [
                              _c("span", [
                                _c("span", [_vm._v("申请加入")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#1E88F5" } },
                                  [_vm._v("【" + _vm._s(d.companyName) + "】")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("管理员-" + _vm._s(d.admin))
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(d.adminMobile))])
                              ]),
                              _vm._v(" "),
                              d.status == 0
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#FF3900" } },
                                    [_vm._v("未通过")]
                                  )
                                : d.status == 1
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#3CC600" } },
                                    [_vm._v("已通过")]
                                  )
                                : d.status == 2
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#1E88F5" } },
                                    [_vm._v("待批准")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(d.createTime))])
                            ]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    !_vm.isnews
                      ? _c("li", { staticClass: "wushuju" }, [
                          _c("img", {
                            attrs: {
                              src: "/static/img/zanwushuju2x.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v("暂无消息")])
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.isnews
                  ? _c(
                      "div",
                      { staticClass: "my-pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "page-size": _vm.size,
                            layout: "prev, pager, next",
                            total: _vm.listtotal
                          },
                          on: { "current-change": _vm.handleCurrentChange }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aq-text" }, [
      _c("p", [
        _vm._v(
          "安全性高的密码可以使账号更安全，建议您定期更换密码，并且设置一个包含数字和字母，长度超过8位以上的密码。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", [_vm._v("内容")]),
      _vm._v(" "),
      _c("span", [_vm._v("状态")]),
      _vm._v(" "),
      _c("span", [_vm._v("时间")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4ae94cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4ae94cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/enterprise.vue
// module id = null
// module chunks = 